<template>
    <main-layout>
        <template #header>
            <main-header :title="'시스템 유저 등록'"></main-header>
        </template>

        <template #body>
            <v-container>
                <v-card>
                    <v-card-text>
                        <v-text-field v-model="editContext.loginId"
                                      placeholder="6자 이상 입력해주세요"
                                      :rules="loginIdRule"
                                      label="로그인 아이디"></v-text-field>
                        <v-text-field v-model="editContext.password"
                                      placeholder="6자 이상 입력해주세요"
                                      :rules="passwordRule"
                                      type="password" label="패스워드"></v-text-field>
                        <v-text-field v-model="editContext.displayName"
                                      placeholder="2자 이상 입력해주세요"
                                      label="닉네임"></v-text-field>
                        <v-text-field v-model="editContext.languageCode"
                                      label="언어코드"></v-text-field>
                        <v-text-field v-model="editContext.countryCode"
                                      label="국가코드"></v-text-field>
                        <v-select :items="systemGroupCodeOptions"
                                  item-text="code"
                                  item-value="code"
                                  label="그룹 권한"
                                  v-model="editContext.permissionGroupCode"></v-select>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text color="primary" :disabled="!valid" @click="register">Register</v-btn>
                    </v-card-actions>
                </v-card>
            </v-container>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainHeader from "@/components/common/layout/MainHeader";
    import TotalCodeOptions from "@/assets/options/TotalCodeOptions";
    import {PATH} from "@/constants";

    export default {
        name: "SystemUserRegister",
        components: {MainHeader, MainLayout},
        mixins: [TotalCodeOptions],
        data() {
            return {
                editContext: {
                    loginId: "",
                    password: "",
                    displayName: "",
                    languageCode: "",
                    countryCode: "",
                    permissionGroupCode: "",
                },
                loginIdRule: [
                    (v) => !!v && v.length >= 6 && v.length <= 20 && !!/^[A-Za-z][A-Za-z0-9]+$/.exec(this.editContext.loginId) || "알파벳으로 시작하며 6자이상 20자 이하여야 합니다."
                ],
                passwordRule: [
                    (v) => !!v && v.length >= 6 && v.length <= 20 && !!/^[A-Za-z][A-Za-z0-9]+$/.exec(this.editContext.loginId) || "알파벳으로 시작하며 6자이상 20자 이하여야 합니다."
                ],
            };
        },
        computed: {
            valid() {
                for (let i = 0; i < this.loginIdRule.length; i++) {
                    if (this.loginIdRule[i](this.editContext.loginId) !== true) return false;
                }
                for (let i = 0; i < this.passwordRule.length; i++) {
                    if (this.passwordRule[i](this.editContext.password) !== true) return false;
                }
                if (this.editContext.loginId.length < 6) return false;
                if (this.editContext.password.length < 6) return false;
                if (this.editContext.displayName.length < 2) return false;
                if (this.editContext.languageCode.length !== 2) return false;
                if (this.editContext.countryCode.length !== 2) return false;
                if (this.editContext.permissionGroupCode.length < 1) return false;
                return true;
            },
        },
        watch: {
            editContext: {
                deep: true,
                handler: function() {
                    this.trimnize();
                },
            },
        },
        created() {
            this.loadSystemGroupCodeOptions();
        },
        methods: {
            trimnize() {
                this.editContext.loginId = this.editContext.loginId.trim();
                this.editContext.password = this.editContext.password.trim();
                this.editContext.displayName = this.editContext.displayName.trim();
                this.editContext.languageCode = this.editContext.languageCode.trim();
                this.editContext.countryCode = this.editContext.countryCode.trim();
                this.editContext.permissionGroupCode = this.editContext.permissionGroupCode.trim();
            },

            async register() {
                this.$requestWithOverlay(PATH.ADMIN_USER.REGISTER)
                    .setObject(this.editContext)
                    .enqueue()
                    .then(() => {
                        this.$alert("시스템 유저가 등록되었습니다.");
                        this.editContext = {};
                    });
            },
        }
    }
</script>

<style scoped>

</style>